import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  class: "keyboard"
};
const _hoisted_2 = ["onClick"];
export default {
  __name: 'index',
  emits: ['input', 'onDelete'],
  setup(__props, {
    emit: __emit
  }) {
    const list = [1, 2, 3, 4, 5, 6, 7, 8, 9];
    const emit = __emit;
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(list, (item, index) => {
        return _createElementVNode("div", {
          class: "van-key",
          key: index,
          onClick: $event => emit('input', item)
        }, _toDisplayString(item), 9, _hoisted_2);
      }), 64)), _cache[2] || (_cache[2] = _createElementVNode("div", {
        class: "van-key"
      }, null, -1)), _createElementVNode("div", {
        class: "van-key",
        onClick: _cache[0] || (_cache[0] = $event => emit('input', 0))
      }, "0"), _createElementVNode("div", {
        class: "van-key",
        onClick: _cache[1] || (_cache[1] = $event => emit('delete'))
      })]);
    };
  }
};